import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'cs-content-divider',
    template: '',
    host: { 'class': 'content-divider' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsContentDividerComponent {

}
